<template>
  <div class="pto_request"  v-if="afterCreated == true">

    <v-row class="pb-5">
            <v-col>
                <h2 class="pt-0 bp-1">2025 Compressed Summer Workweek Program: </h2>
                <ul>
                  <li>For 12 weeks starting May 30 through August 15, 2025.</li>
                  <li>Available to all full-time and part-time non-union and Local 153 employees.</li>
                  <li>* Non-exempt timesheets (which are now electronic) should reflect all hours and days worked, including lunch.</li>
                  <li><b>Two Options:</b>
                    <ul>
                      <li><b>Compressed Workweek:</b> Work regular workdays Monday through Friday, taking only 30 minutes for lunch instead of one hour. This enables you to end work 2.5 hours earlier on Friday without affecting accrued paid time off (PTO).</li>
                      <li><b>Regular workweek:</b> Choose not to participate in the compressed summer workweek, leaving your workweek, days and lunch hours unchanged.</li>
                    </ul>
                  </li>
                </ul>
            </v-col>
        </v-row>

    <v-form ref="pto_form" v-model="valid" lazy-validation>
      <v-row pt-50>
        <v-col
          class="prompt first-row"
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
          >Legal Name</v-col
        >
        <v-col 
          class="first-row"
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom9cols: $vuetify.breakpoint.smAndUp,
          }"
        >
           {{firstname}}  {{lastname}} 
           <span style="display:none;"> {{this.firstname}} </span>

          <v-tooltip right v-model="show_tooltip_legal_name" max-width="300px">
            <template v-slot:activator="{}">
              <v-btn
                v-click-outside="hide_legal_name"
                @click="showTooltip('legal_name')"
                icon
                aria-label="More information"
              >
                <v-icon>mdi-information</v-icon>
              </v-btn>
            </template>
            <span>{{ this.tooltips.legal_name }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
        >
          <v-subheader class="pl-0 prompt">Opt-In</v-subheader>
        </v-col>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
        >
          <v-switch
            v-model="opt_in"
            aria-label="Opt-in for Compressed Workweek"
            @change="populate()"
          ></v-switch>
        </v-col>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            hidden: $vuetify.breakpoint.smAndUp,
          }"
        >
        </v-col>
      </v-row>

      <v-row>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">Compressed Day</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom9cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-select
              v-model="compressed_day"
              :items="compressed_days"
              :disabled="opt_in == true ? false : true"
              item-value="id"
              item-text="name"
              aria-label="Compressed Day"
              class="messages"
              id="comp_day_id"
              outlined
              single-line
              dense
              required
              :menu-props="{maxHeight: '350'}"
            />
          </v-col>
        </v-row>

      <v-row class="submit-row">
        <v-col cols="12">
          <v-btn
            class="ma-2"
            color="#FFB500"
            :disabled="!valid"
            depressed 
            @click="submitCompWeek"
          >
            Submit Changes
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <div class="text-center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ dialog_title }}
          </v-card-title>
          <v-card-text>{{ dialog_text }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog(dialog_type)">
              {{ dialog_ok }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import axios from "axios";
import pto_func from "@/pto_functions";

export default {
  directives: {
    ClickOutside,
  },

  props: ["ptoInfo"],

  data: () => ({

    dialog: false,
    dialog_title: "Alert!",
    dialog_ok: "OK",
    dialog_text: "",
    dialog_type: "",
    valid: true,
    show_tooltip_legal_name: false,
    afterCreated: false,

    cur_fiscal_year: pto_func.get_fiscal_year("cur_long"),
    firstname: "",
    lastname: "",
    showCompWeekInfo: false,
    showCompWeekForm: false,
    isFaculty: false,
    opt_in: "",
    opt_in_ori: "",
    compressed_day: "",
    compressed_day_ori: "",

    tooltips: {
      legal_name:
        "This is the legal name listed on your official W2 forms and may also be needed to ensure the accuracy of claims with benefits. If you change your legal name, please contact Human Resources.",
    },

    compressed_days: pto_func.getCompDays("object"),

    input: [
      {
        opt_in: "",
        compressed_day: "",
      },
    ],

  }),

  methods: {

    showTooltip(name) {
      eval("this.show_tooltip_" + name + " = true");
    },

    populate() {      
      if (this.opt_in == false) {
        this.compressed_day = "" ;
      } else {  // opt_in clicked
        if (this.compressed_day_ori)
          this.compressed_day = this.compressed_day_ori ;
        else
          this.compressed_day = "" ;
      }
      return;
    },

    hide_legal_name() {
      this.show_tooltip_legal_name = false;
    },

    closeDialog() {
      this.dialog = false;

      if (this.dialog_type == "success") {
        window.location.reload();
      } else if (this.dialog_type == "balance") {
        this.$router.push({
          path: "/pto/balance",
        });
      }
    },     

    submitCompWeek() {
      
      if (this.validateRequest() == false) {
        return;
      }

        axios
          .post("./remote-apis/ptoSubmitComp.php", {
            opt_in: JSON.stringify(this.opt_in),
            day: JSON.stringify(this.compressed_day),            
          })
          .then((res) => { 
            
            if (res.data.response == "OK") {
              this.dialog_title = "Thank you!";
              this.dialog_text =
                "Your selection has been submitted.";
              this.dialog_type = "success";
              this.dialog = true;
            } else if (res.data.response == "FAILURE") {
              this.dialog_title = "Alert!";
              if (res.data.message) {
                this.dialog_text = res.data.message;
              } else {
                if (this.opt_in == this.opt_in_ori && this.compressed_day == this.compressed_day_ori) {
                  this.dialog_text = "Your selections are on file already."
                } else {
                  this.dialog_text = "Cannot process your request. Please try again later.";
                }
              }
              this.dialog_type = "failure";
              this.dialog = true;
            } else if (res.data.response == "FAILED") {
              this.dialog_title = "Alert!";
              if (res.data.message)
                this.dialog_text = res.data.message;
              else
              this.dialog_text =
                "Cannot process your request. Please try again.";
              this.dialog_type = "warning";
              this.dialog = true;              
            } else if (res.data.response == "DEBUG") {
              this.dialog_title = "Debug title";
              if (res.data.message)
                this.dialog_text = res.data.message;
              else
                this.dialog_text = "Debug text";
              this.dialog_type = "debug";
              this.dialog = true;
            } 
          })
          .catch((error) => {
            window.console.log(error);
            this.dialog_title = "Alert!";
              this.dialog_text =
                "Cannot process your request.";
              this.dialog_type = "alert";
              this.dialog = true;
          });
      
    },

    /////////////////
    validateRequest() {
      
      var input_opt_in = this.opt_in;
      var input_compressed_day = this.compressed_day ;

      if (input_opt_in && !input_compressed_day) {
          this.dialog_text = "Please select 'Compressed Day'";
          this.dialog_type = "error";
          this.dialog = true;
          return false;
      }

     return true;
      
    },

   

  }, // methods

  created() {

    this.showCompWeekForm = this.ptoInfo.showCompWeekForm; 
    //this.showCompWeekInfo = this.ptoInfo.showCompWeekInfo; 
    //this.showCompWeekBadge = this.ptoInfo.showCompWeekBedge; 
    this.isFaculty = this.ptoInfo.isFaculty;
    this.opt_in = this.ptoInfo.cw_opt_in; 
    this.opt_in_ori = this.opt_in;
    this.compressed_day = this.ptoInfo.cw_day; 
    this.compressed_day_ori = this.compressed_day;
    
    if (this.isFaculty == true) {   
      this.$router.push({
          path: "/pto/manager",
        });
        return false;
    }

    if (this.showCompWeekForm == false) {   
      this.$router.push({
          path: "/pto/request",
        });
        return false;
    }

    axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.cur_fiscal_year).then((response) => {
        this.saas_data = response.data;
        this.firstname = this.saas_data.firstname;
        this.lastname = this.saas_data.lastname;
      });

    this.afterCreated = true;

 },

  mounted() {  
    
  } 

   
};

</script>

<style scoped>
.custom1cols {
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  padding-left: 0px;
  padding-bottom: 0px;
}

.custom3cols {
  width: 25%;
  max-width: 25%;
  flex-basis: 25%;
  padding-left: 5px;
  padding-bottom: 0px;
}

.custom4cols {
  width: 33%;
  max-width: 33%;
  flex-basis: 33%;
  padding-bottom: 0px;
}

.custom9cols {
  width: 75%;
  max-width: 75%;
  flex-basis: 75%;
  padding-bottom: 0px;
}

.hidden {
  display: none;
}

.v-input {
  max-width: 80%;
}

.messages /deep/ .v-messages,
.messages /deep/ .v-messages__message {
  font-size: 16px !important;
}

.black--text /deep/ label {
  color: #000000 !important;
  font-weight: 400 !important;
}
.dt-picker /deep/ .v-btn {
  border-radius: 28px !important;
}

.dt-picker_ /deep/ .v-btn--outlined {
  border: 4px solid #ffb500 !important;
  color: #4f2c1d !important;
}

.dt-picker_ /deep/ .v-date-picker-table .v-btn.v-btn--active {
  color: #4f2c1d !important;
}

.prompt {
  font-weight: bold;
  font-size: 1em;
  color: #000 !important;
}

.first-row__ {
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 12px 12px 12px 0;
}

.field-row__ {
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 12px 12px 12px 0;
}

.inst {
  margin-top: 1px;
  font-style: italic;
  font-size: 13px;
  width: 80%;
  padding-bottom: 0;
  margin-bottom: 0;
}

.inst a {
  text-decoration-color: #ffb500 !important;
  text-decoration-thickness: 2px !important;
  text-decoration: underline;
}

.submit-row {
  padding: 12px 0 24px 0;
  margin-bottom: 50px;
}

.row {
  padding-top: 0;
  padding-bottom: 0;
}

.alert_spacing {
  margin-right: 5px !important;
}

</style>

